/**
 * Theme Provider (Dark Mode Support)
 *
 * Uses next-themes for theme management.
 */


import { ThemeProvider as NextThemesProvider } from 'next-themes'
import type { ThemeProviderProps as NextThemesProviderProps } from 'next-themes'

type ThemeProviderProps = NextThemesProviderProps

export function ThemeProvider({
  children,
  ...props
}: ThemeProviderProps) {
  return <NextThemesProvider {...props}>{children}</NextThemesProvider>
}
